import { Container } from '../components/Container';

export function LegalLayout({ title, updatedDate, children }) {
  return (
    <main className="bg-white">
      <Container className="py-14 sm:py-16">
        <header className="max-w-3xl">
          <p className="text-sm font-medium tracking-wide text-slate-600">
            Grow With Call
          </p>
          <h1 className="mt-2 text-3xl font-semibold tracking-tight text-slate-900 sm:text-4xl">
            {title}
          </h1>
          <p className="mt-4 text-sm text-slate-600">
            Last updated: {updatedDate}
          </p>
        </header>

        <div className="mt-10 max-w-3xl space-y-8 text-sm leading-7 text-slate-700">
          {children}
        </div>
      </Container>
    </main>
  );
}

